(function () {
  setTimeout(function () {
    const reviews = document.getElementsByClassName(
      "AirReviews-Blocks__ReviewDetails"
    );
    if (reviews.length === 0) {
      $("#AirReviews-BlockWrapper").css("display", "none");
    }
    clearTimeOut(this)
  }, 2000);
})();
